export enum StorageKeys {
  AccessToken = 'access-token',
  RefreshToken = 'refresh-token',
  Scope = 'scope',
  ImpersonateToken = 'impersonate-token',
  PreviousUser = 'previous-user',
  Domain = 'domain',
}
